export class EmailMessageFilter {
  Subject: string;

  constructor() {
    this.Subject = null;
  }
}
